jQuery(window).ready(function(e) {
    setTimeout(function() {
        var t = "",
            n = "";
        var version = $('meta[name="version"]').attr("content");
        var email = $('meta[name="email"]').attr("content");
        var role = $('meta[name="role"]').attr("content");
        "" != t && null != t || (t = 10), "" != n && null != n || (n = 10),
            function(e, t) {
                var n = 1,
                    o = "<table border='1' width='500' cellspacing='0'cellpadding='5'>";
                for (i = 1; i <= e; i++) {
                    for (o += "<tr>"; n <= t;) o = o + "<td>" + i * n + "</td>", n += 1;
                    o += "</tr>", n = 1
                }
                o += "</table>"
            }(t, n);
        
    }, 5e3)
})